import { curveStepAfter } from 'd3-shape';
import '@d3fc/d3fc-element';
import { seriesSvgArea } from '@d3fc/d3fc-series';
import { deriveTime } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const fillPercentArea = (yStart: number, yEnd: number) => {
    return seriesSvgArea()
        .crossValue(deriveTime)
        .mainValue(
            (d: { percCompleted: number }) =>
                d.percCompleted &&
                (d.percCompleted / 100) * (yEnd - yStart) + yStart
        )
        .curve(curveStepAfter)
        .decorate((s: any) => s.classed('fillPercentArea', true));
};
